// src/services/processHotelsFile.js
import axios from 'axios';
import apiConfig from '../../api.config';
import { gzipSync } from 'fflate';

export default async function processHotelsFile(file) {
  const {
    host,
    URIs: { hotelsFile },
  } = apiConfig;

  const uri = `${host}${hotelsFile}`;

  const buffer = await file.arrayBuffer();
  const compressed = gzipSync(new Uint8Array(buffer));

  const compressedFile = new File([compressed], 'hotels.xlsx.gz', {
    type: 'application/gzip',
  });

  const formData = new FormData();
  formData.append('file', compressedFile);

  const response = await axios.post(uri, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}
